/**
 * IDs de participants à ignorer/masquer dans toute l'application.
 * Ces participants système (ex: bot d'enregistrement Teams) ne doivent
 * pas apparaître dans les listes, métriques ou transcripts.
 */
export const IGNORED_PARTICIPANT_IDS: readonly string[] = [
  'bdd75849-e0a6-4cce-8fc1-d7c0d4da43e5', // Teams meeting recorder invisible user
  '8e55a7b1-6766-4f0a-8610-ecacfe3d569a', // Copilot
  'cb3e42e4-9965-4f72-9d68-48d605da5cac',
];

export function isIgnoredParticipant(id: string): boolean {
  return IGNORED_PARTICIPANT_IDS.includes(id);
}
